export const styleSheet = () => ({
    container: {
        position: 'relative'
    },
    img: {
        width: '100%'
    }
});
